import { render } from "./showTip.vue?vue&type=template&id=5786d21e&scoped=true&lang=pug"
import script from "./showTip.vue?vue&type=script&setup=true&lang=js"
export * from "./showTip.vue?vue&type=script&setup=true&lang=js"

import "./showTip.vue?vue&type=style&index=0&id=5786d21e&scoped=true&lang=css"

import exportComponent from "/Users/liu/Downloads/cross-bridge v0.1.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5786d21e"]])

export default __exports__